

import {request} from "@/network/request.js";
export function randomArr(min, max) {
	if(min && max) {
		return Math.round(Math.random() * (max - min)) + min;
	}
}


export function fn_overload(num) {
	if(typeof(num) != 'number') {
		num = num * 1
	}
	if (num > 999) {     //字数是否过千
		var sen = num / 1000;    //过千处理
		var vals = sen.toFixed(2)    //保留小数
		return vals + "k"      //字符串拼接
	} else {
		return num
	}  
}
export function getThisYear() {
	let arr = []
	const start = new Date(new Date().getFullYear(), 0);
	const end = new Date();

	let timestamp1 = Date.parse(start)
	let timestamp2 = Date.parse(end)
	let t1 = ((timestamp1 + '').slice(0, 10)) * 1
	let t2 = ((timestamp2 + '').slice(0, 10)) * 1
	arr.push(t1)
	arr.push(t2)
	return JSON.stringify(arr)
}

// 获取主管部门
export function get_admin_department() {
    return request({
        url: '/hkt/department/get_admin_department',
        params: { }
    })
}

// 获取成员列表
// pagesize	是	int	页码
// user_name	否	string	账号
// role_id	否	int	角色id
// department_id	否	int	部门id
export function get_member_detailed_list(params) {
    return request({
        url: '/hkt/member/get_member_detailed_list',
        params,
    })
}
// ----------------------------------------------------------------
// 数据大盘
// member_id	否	int	成员id
// search_time	是	json	搜索时间
export function get_customer_kanban_market(params) {
    return request({
        url: '/hkt/cutomerkanban/get_customer_kanban_market',
        params,
    })
}
// 分享
export function get_customer_kanban_share(params) {
    return request({
        url: '/hkt/cutomerkanban/get_customer_kanban_share',
        params,
    })
}
// 4个 图表数据
export function get_customer_kanban_data(params) {
    return request({
        url: '/hkt/cutomerkanban/get_customer_kanban_data',
        params,
    })
}
// 榜单
export function get_customer_kanban_list(params) {
    return request({
        url: '/hkt/cutomerkanban/get_customer_kanban_list',
        params,
    })
}

export function getSecondTime(time) {
	if(time && typeof(time) == 'number') {
		// 转换为式分秒
		let h = parseInt(time / 60 / 60 % 24)
		let m = parseInt(time / 60 % 60)
		let s = parseInt(time % 60)
		h = h > 9 ? h : '0' + h;
		m = m > 9 ? m : '0' + m;
		s = s > 9 ? s : '0' + s;
		// 作为返回值返回
		let t = `${h||'00'}:${m||'00'}:${s||'00'}`
		console.log(t,'getSecondTime')
		return t
	}
	else {
		return '--'
	}
}
